import {styled} from "@phntms/css-components";
import styles from "./styles.module.scss";

export const CardsGridSectionContainer = styled('section' , {
  css: [styles.cardsGridSection, 'container', 'cards-grid-section']
})





